import React, { useEffect, useState } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
import { BsArrowBarUp } from "react-icons/bs";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { IoMdNotificationsOutline } from "react-icons/io";
import { MdOutlineNotificationsActive } from "react-icons/md";
import avatar from "assets/img/avatars/avatar4.png";
import {fetchData} from "../../services/ApiFetching"; // your custom fetch wrapper

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = localStorage.getItem("username") || "User";
  const userId = localStorage.getItem("id");

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        const data = await fetchData(`notifications/${userId}`);
        setNotifications(data || []);
      } catch (error) {
        console.error("Failed to load notifications", error);
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    loadNotifications();
  }, []);

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      {/* Brand Name */}
      <div className="ml-[6px] mr-[25px] hidden sm:block">
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link to="#" className="font-bold capitalize hover:text-navy-700 dark:hover:text-white">
            {brandText}
          </Link>
        </p>
      </div>

      {/* Right Section */}
      <div className="relative mt-[3px] flex h-[61px] w-100 flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none sm:flex-grow-0 md:gap-1 xl:gap-2">
        
        {/* Sidebar Toggle */}
        <span className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden ml-3" onClick={onOpenSidenav}>
          <FiAlignJustify className="h-7 w-7" />
        </span>

        {/* Notification Dropdown */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-8 w-8 text-gray-600 dark:text-white ml-3" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">Notification</p>
              </div>

              {loading ? (
                <p className="text-sm text-center text-gray-500 dark:text-white">Loading...</p>
              ) : notifications.length === 0 ? (
                <p className="text-sm text-center text-gray-500 dark:text-white">No notifications available</p>
              ) : (
                notifications.map((notif, index) => (
                  <button key={index} className="flex w-full items-center">
                    <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                      <MdOutlineNotificationsActive />
                    </div>
                    <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                      <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                        New Message By: {notif.sent_by}
                      </p>
                      <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                        {notif.message}
                      </p>
                    </div>
                  </button>
                ))
              )}
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />

        {/* Theme Toggle */}
        <div
          className="cursor-pointer text-gray-600 mx-3"
          onClick={() => {
            document.body.classList.toggle("dark");
            setDarkmode(!darkmode);
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-7 w-7 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-7 w-7 text-gray-600 dark:text-white" />
          )}
        </div>

        {/* Profile Dropdown */}
        <Dropdown
          button={
            <img className="h-10 w-10 rounded-full cursor-pointer" src={avatar} alt="avatar" />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, {user}
                  </p>
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />
              <div className="flex flex-col p-4">
                <Link to="/profile" className="text-sm text-gray-800 dark:text-white hover:dark:text-white">Profile</Link>
                <a href=" " className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white">Settings</a>
                <Link
                  to="/auth/sign-in"
                  onClick={() => localStorage.clear()}
                  className="mt-3 text-sm font-medium text-red-500 hover:text-red-500 transition duration-150 ease-out hover:ease-in"
                >
                  Log Out
                </Link>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
